import { render, staticRenderFns } from "./LogoSelector.vue?vue&type=template&id=73d352ac"
import script from "./LogoSelector.vue?vue&type=script&lang=js"
export * from "./LogoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports